import React from 'react';
import {Outlet} from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import {Container, Box} from '@mui/material';

const MainLayout: React.FC = () => {
    return (
        <Box sx={{display: 'flex', flexDirection: 'column', minHeight: '100vh'}}>
            <Header/>
            <Container sx={{flexGrow: 1, paddingTop: '2rem'}} maxWidth="xl">
                <Outlet/>
            </Container>
            <Footer/>
        </Box>
    );
};

export default MainLayout;
